//
//
//
//
//
//
//

export default {
  data() {
    return {
      isPhonex: false,
    }
  },
  created() {
    this.isPhonex = this.IPHONEX
  },
 
}
